import React, {Component} from 'react';
import Sounds from "./Sounds";


class App extends Component {

  render () {
    return(
        <Sounds/>
    )
  }
}

export default App;
